import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const DisclaimerCard = () => {
  const { t } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);

  // A) Set default state based on screen size
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024;
      // Get stored state or use default (desktop expanded, mobile collapsed)
      const storedState = localStorage.getItem('dca_disclaimer_expanded');
      if (storedState !== null) {
        setIsExpanded(JSON.parse(storedState));
      } else {
        setIsExpanded(!isMobile);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // A) Persist state in localStorage per device
  const toggleDisclaimer = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    localStorage.setItem('dca_disclaimer_expanded', JSON.stringify(newState));
  };

  return (
    <Card className="bg-[#0b1c38] border-[#0677aa] shadow-xl">
      <CardContent className="pt-6">
        <div className="flex items-start gap-3">
          <Info className="w-5 h-5 text-[#0677aa] flex-shrink-0 mt-0.5" />
          <div className="flex-1 text-sm leading-relaxed">
            {/* Title with toggle button */}
            <div className="flex items-center justify-between mb-2">
              <div 
                className="font-bold text-[#00f4ff]"
                dangerouslySetInnerHTML={{
                  __html: t('disclaimer').split(':')[0] + ':'
                }}
              />
              {/* A) Toggle button with proper touch targets (≥44px) */}
              <button
                onClick={toggleDisclaimer}
                className="flex items-center gap-1 px-3 py-2 text-xs text-[#00f4ff] hover:text-[#12b7ff] transition-colors focus:outline-none focus:ring-2 focus:ring-[#00f4ff] focus:ring-offset-2 focus:ring-offset-transparent rounded min-h-[44px] min-w-[44px] justify-center"
                aria-expanded={isExpanded}
                aria-label={isExpanded ? t('seeLess') : t('seeMore')}
              >
                <span className="hidden sm:inline">
                  {isExpanded ? t('seeLess') : t('seeMore')}
                </span>
                {isExpanded ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>
            </div>
            
            {/* A) Content with smooth CSS animation (200-300ms) */}
            <div 
              className="overflow-hidden transition-all duration-300 ease-in-out"
              style={{
                maxHeight: isExpanded ? '1000px' : '0px',
                opacity: isExpanded ? 1 : 0
              }}
            >
              <div 
                className="text-white pb-2"
                style={{ opacity: 0.85, lineHeight: '1.6' }}
                dangerouslySetInnerHTML={{
                  __html: t('disclaimer').split(':').slice(1).join(':').trim()
                }}
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DisclaimerCard;